import React from "react";
import {
  TextInput,
  StyleSheet,
  View,
  Button,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Modal,
  FlatList,
  Platform,
  SafeAreaView,
  KeyboardAvoidingView,
  Linking,
} from "react-native";
import { Auth } from "aws-amplify";
import { useNavigation } from "@react-navigation/native";
import IntlPhoneInput from "react-native-intl-phone-input";
import PhoneInput from "react-native-phone-number-input";
import { Ionicons } from "@expo/vector-icons";
import GenericButton from "../GenericButton";

export default function ForgotPassword() {
  const [username, onChangeUserText] = React.useState("");
  const [password, onChangePassText] = React.useState("");
  const [authCode, onChangeAuthCodeText] = React.useState("");

  const [step, onChangeStep] = React.useState(0);

  const [errorMsg, onErrorMsg] = React.useState("");

  const navigation = useNavigation();

  const [phone, onChangePhoneText] = React.useState("");
  const [value, setValue] = React.useState("");
  const [valueCode, setValueCode] = React.useState("61");
  const [formattedValue, setFormattedValue] = React.useState("");
  const platform = Platform.OS;

  const tryResetPassword = async (username) => {
    // inject phone numebr adn do stuff pnone number clean up

    var un = "";
    if (platform === "web") {
      un = value;
      if (un.charAt(0) == "0") un = un.substring(1);
      un = "+" + valueCode + un;
    } else {
      un = phone.unmaskedPhoneNumber;
      if (un.charAt(0) == "0") un = un.substring(1);
      un = phone.dialCode.concat(un);
    }
    username = un;

    if (username === "") {
      onErrorMsg("Please enter Phone");
    } else {
      try {
        onChangeUserText(username);
        const res = await Auth.forgotPassword(username);
        onChangeStep(1);
      } catch (error) {
        onErrorMsg(error.message);
      }
    }
  };

  const forgotPasswordSubmit = async (username, password, authCode) => {
    if (password === "") {
      onErrorMsg("Please enter New Password");
    } else if (authCode === "") {
      onErrorMsg("Please enter Authcode");
    } else {
      try {
        await Auth.forgotPasswordSubmit(username, authCode, password);
        // console.log("password reset");
        navigation.navigate("Login");
      } catch (error) {
        onErrorMsg(error.message);
      }
    }
  };

  var phoneInput;

  var renderCustomModal = (modalVisible, countries, onCountryChange) => (
    <Modal visible={modalVisible}>
      <View style={styles.phoneModalContainer}>
        <TouchableOpacity
          onPress={() => phoneInput.hideModal()}
          style={styles.phoneModalClose}
        >
          <Ionicons
            name="md-arrow-back"
            size={20}
            style={styles.HbackArrowBlack}
          />
        </TouchableOpacity>
        <View style={styles.phoneModalInputContainer}>
          <View style={styles.phoneModalListItemFlag}>
            <Ionicons
              name="md-search"
              size={24}
              style={styles.phoneModalIcon}
            />
          </View>
          <View style={styles.phoneModalListItemCountry}>
            <TextInput
              onChangeText={(v) => phoneInput.filterCountries(v)}
              placeholder="Country Filter"
              style={styles.phoneModalInputField}
            />
          </View>
          <View style={styles.phoneModalListItemDailcode}></View>
        </View>
        <FlatList
          style={styles.phoneModalList}
          data={countries}
          keyExtractor={(item, index) => index.toString()}
          renderItem={({ item }) => (
            <TouchableWithoutFeedback
              onPress={() => onCountryChange(item.code)}
            >
              <View style={styles.phoneModalListItem}>
                <View style={styles.phoneModalListItemFlag}>
                  <Text style={styles.phoneModalListIemFlagText}>
                    {item["flag"]}
                  </Text>
                </View>
                <View style={styles.phoneModalListItemCountry}>
                  <Text style={styles.phoneModalListIemText}>{item["en"]}</Text>
                </View>
                <View style={styles.phoneModalListItemDailcode}>
                  <Text style={styles.phoneModalListIemText}>
                    {item["dialCode"]}
                  </Text>
                </View>
              </View>
            </TouchableWithoutFeedback>
          )}
        />
      </View>
    </Modal>
  );

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView style={styles.container} behavior="padding" enabled>
        {step === 0 ? (
          <View style={styles.container}>
            <View style={styles.infoBox}>
              <View style={styles.inputContainer}>
                <View style={styles.textInputNoUnderline}>
                  {/*
              <TextInput
                style={styles.textInput}
                placeholder="Phone (Including country code)"
                placeholderTextColor="#adb4bc"
                value={username}
                onChangeText={(text) => onChangeUserText(text)}
              />
             */}
                  {platform === "web" ? (
                    <View style={styles.flexStyle}>
                      <PhoneInput
                        defaultCode={"AU"}
                        onChangeCountry={(text) => {
                          setValueCode(text.callingCode[0]);
                        }}
                        ref={phoneInput}
                        defaultValue={value}
                        onChangeText={(text) => {
                          setValue(text);
                        }}
                        onChangeFormattedText={(text) => {
                          setFormattedValue(text);
                        }}
                        placeholder="Phone"
                        autoFocus={true}
                        containerStyle={{
                          width: 50,
                        }}
                        codeTextStyle={{
                          fontSize: 16,
                          fontFamily: "montserrat-regular",
                          color: "#2f7185",
                        }}
                        textContainerStyle={{
                          backgroundColor: "transparent",
                          marginLeft: 0,
                          paddingLeft: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                        }}
                        layout={"second"}
                        textInputStyle={{
                          ...Platform.select({
                            web: {
                              outlineStyle: "none",
                            },
                          }),
                          fontSize: 16,
                          fontFamily: "montserrat-regular",
                          height: 40,
                          left: 0,
                          //backgroundColor: "green",
                          width: 160,
                        }}
                        flagButtonStyle={{
                          marginTop: 10,
                          width: 75,
                          paddingBottom: 15,
                        }}
                      />
                    </View>
                  ) : (
                    <View style={styles.flexStyle}>
                      <Text style={styles.formLabelStyle}>Phone</Text>
                      <IntlPhoneInput
                        onChangeText={onChangePhoneText}
                        ref={(ref) => (phoneInput = ref)}
                        customModal={renderCustomModal}
                        defaultCountry="AU"
                        placeholder=""
                        containerStyle={{
                          flex: 3,
                        }}
                        flagStyle={{ display: "none" }}
                        // filterInputStyle={styles.textInput}
                        dialCodeTextStyle={{
                          fontSize: 16,
                          fontFamily: "montserrat-regular",
                          color: "#2f7185",
                        }}
                        phoneInputStyle={{
                          fontSize: 16,
                          fontFamily: "montserrat-regular",
                        }}
                        modalCountryItemCountryNameStyle={{
                          color: "black",
                          // flagStyle: { display: "none" },
                        }}
                      />
                    </View>
                  )}
                </View>
              </View>
              <Text style={styles.TextStyleError}>{errorMsg}</Text>
            </View>
            {/* This commented section can be removed in 7/11/2023 */}
            {/* <TouchableOpacity
              style={styles.SubmitButtonStyle}
              onPress={() => {
                tryResetPassword(username);
              }}
            >
              <Text style={styles.TextStyleBlack}>SEND RESET CODE</Text>
            </TouchableOpacity> */}
            <GenericButton
              buttonText='SEND RESET CODE'
              onPress={() => {
                tryResetPassword(username);
              }}
            />
            <Text style={[styles.TextStyleLink, { fontFamily: 'montserrat-medium' }]}>Forgot your login? Enter the number you registered with to receive a reset code.</Text>
            <Text style={[styles.TextStyleLink, { fontFamily: 'montserrat-medium' }]}>
              Or contact our&nbsp;
              <Text style={styles.TextStyleLinkLink}
                onPress={() => {
                  Platform.OS !== "web"
                    ? Linking.openURL("https://aura.club/contact/")
                    : window.open("https://aura.club/contact/", "_blank");
                }}>support team.
              </Text>
            </Text>
          </View>
        ) : (
          <></>
        )}
        {step === 1 ? (
          <View style={styles.container}>
            <View style={styles.infoBox}>
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="Confirmation code"
                  placeholderTextColor="#adb4bc"
                  keyboardType={"numeric"}
                  returnKeyType="done"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={false}
                  value={authCode}
                  onChangeText={(text) => onChangeAuthCodeText(text)}
                />
              </View>
              {/*  password section  */}
              <View style={styles.inputContainer}>
                <TextInput
                  style={styles.textInput}
                  placeholder="New Password"
                  placeholderTextColor="#adb4bc"
                  returnKeyType="next"
                  autoCapitalize="none"
                  autoCorrect={false}
                  secureTextEntry={true}
                  value={password}
                  onChangeText={(text) => onChangePassText(text)}
                />
                <Text style={styles.TextStylePassword}>
                  At least 8 Characters.
                </Text>
                <Text style={styles.TextStylePassword}>
                  (With 1 letter and 1 number.)
                </Text>
                <Text style={styles.TextStyleError}>{errorMsg}</Text>
              </View>
            </View>
            <TouchableOpacity
              style={styles.SubmitButtonStyle}
              onPress={() => {
                forgotPasswordSubmit(username, password, authCode);
              }}
            >
              <Text style={styles.TextStyle}>CHANGE PASSWORD</Text>
            </TouchableOpacity>
          </View>
        ) : (
          <></>
        )}
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  textInputNoUnderline: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },
  flexStyle: {
    flex: 1,
    flexDirection: "row",
  },
  TextStyleLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 10,
    lineHeight: 25
  },
  TextStyleLinkLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    paddingTop: 10,
    lineHeight: 25,
    textDecorationLine: "underline",
  },
  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
  },
  container: {
    width: 350,
    alignSelf: "center",
  },
  infoBox: {
    backgroundColor: "#ffffff",
    borderRadius: 15,
    marginBottom: 20,
    padding: 20,
  },
  buttonStyle: {
    alignItems: "center",
    backgroundColor: "#b44666",
    padding: 14,
    marginBottom: 10,
    borderRadius: 3,
  },
  xxxtextStyle: {
    padding: 5,
    fontSize: 14,
    color: "#fff",
    fontWeight: "bold",
  },
  inputContainer: {
    paddingTop: 15,
  },
  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: "none",
      },
    }),
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
  },
  TextStyle: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },
  TextStyleBlack: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },
  SubmitButtonStyle: {
    marginBottom: 30,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#FFC40C",
    borderRadius: 30,
  },
  TextStyleError: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    paddingTop: 10,
  },
  TextStylePassword: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    paddingTop: 3,
  },
  phoneModalSafeArea: {
    height: "100%",
  },
  phoneModalContainer: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 48,
  },
  phoneModalClose: {
    alignItems: "flex-start",
    justifyContent: "center",
    marginBottom: 20,
    height: 40,
    paddingLeft: 5,
  },
  phoneModalIcon: {
    paddingLeft: 5,
  },
  phoneModalText: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 18,
  },
  phoneModalInputContainer: {
    flexDirection: "row",
  },
  phoneModalInputField: {
    color: "#000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 18,
    marginBottom: 20,
    width: "100%",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    paddingBottom: 5,
  },
  phoneModalList: {
    height: "80%",
  },
  phoneModalListItem: {
    flexDirection: "row",
    alignItems: "center",
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    paddingBottom: 10,
    paddingTop: 10,
  },
  phoneModalListItemFlag: {
    width: 60,
  },
  phoneModalListIemFlagText: {
    fontSize: 22,
  },
  phoneModalListItemCountry: {
    flex: 15,
  },
  phoneModalListItemDailcode: {
    flex: 1,
    minWidth: 30,
  },
  phoneModalListIemText: {
    color: "#000",
    fontFamily: "montserrat-regular",
    fontSize: 15,
  },
  TextStyleOR: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    marginTop: 15,
  },
  TextStyleResend: {
    padding: 5,
    fontSize: 12,
    color: "#337599",
    fontWeight: "bold",
    textAlign: "center",
  },
  SubmitButtonStyleNone: {
    marginTop: 0,
    marginLeft: 50,
    marginRight: 50,
    paddingTop: 15,
    paddingBottom: 15,
    borderRadius: 30,
    justifyContent: "center",
  },
});
